import React from 'react';
import { cn } from '../../design-system/cn';
import { semanticColors, radii, spacing, shadows } from '../../design-system/tokens';
import { glassSurfaces } from '../../design-system/tokens/surfaces';

export default function EmptyState({
  icon = '📭',
  title,
  description,
  variant = 'dashed',
  className,
  children,
}) {
  if (variant === 'glass') {
    return (
      <div
        className={cn(
          'border text-center',
          glassSurfaces.elevated,
          shadows.premiumGlass,
          radii.card,
          spacing.card.md,
          className,
        )}
      >
        {icon && <span className="text-4xl mb-4 block" aria-hidden>{icon}</span>}
        {title && (
          <p className={cn(
            'text-sm font-black uppercase tracking-widest mb-2',
            semanticColors.text.primary,
          )}
          >
            {title}
          </p>
        )}
        {description && (
          <p className={cn('text-xs font-medium', semanticColors.text.secondary)}>{description}</p>
        )}
        {children}
      </div>
    );
  }

  if (variant === 'simple') {
    return (
      <p className={cn(
        'text-center text-xs font-bold py-8',
        semanticColors.text.muted,
        className
      )}
      >
        {description || title}
      </p>
    );
  }

  return (
    <div
      className={cn(
        'border-2 border-dashed text-center',
        semanticColors.border.empty,
        radii.empty,
        spacing.card.lg,
        className
      )}
    >
      {icon && <span className="text-4xl mb-4 block" aria-hidden>{icon}</span>}
      {title && (
        <p className={cn(
          'text-sm font-black uppercase tracking-widest mb-2',
          semanticColors.text.muted
        )}
        >
          {title}
        </p>
      )}
      {description && (
        <p className={cn('text-xs font-medium', semanticColors.text.subdued)}>{description}</p>
      )}
      {children}
    </div>
  );
}
